import { ActionType, ShiftAction, ShiftStore } from "./model";

const initialState: ShiftStore = {
  showToast: "",
};

const shiftStore = (state = initialState, action: ShiftAction): ShiftStore => {
  switch (action.type) {
    case ActionType.SET_SHOW_TOAST:
      return {
        ...state,
        showToast: action.data?.showToast ?? "",
      };

    case ActionType.UPDATE_SHARED_SHIFT_SLOT:
      return {
        ...state,
        sharedShiftSlot: action.data?.sharedShiftSlot,
      };

    default:
      return state;
  }
};

export { shiftStore };
